import { DECOMMISSIONED, OPERATIONAL } from '../constants';
import { type DOI } from './doi';

export function getOperationalStatus(doi: DOI): string | undefined {
  if (!doi.operationalPeriod) {
    return undefined;
  }

  // `operationalPeriod` is either a single start date, or a `start/end` range
  const [, operationalEnd] = doi.operationalPeriod.split('/');
  return operationalEnd ? DECOMMISSIONED : OPERATIONAL;
}
